/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { releaseDate, representative, agencyName, agencyTax, sendTo } = formField;

  return (
    <Box mt={5}>
      <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
        4 Thông tin đơn vị chủ quản (trường hợp tổ chức, cá nhân dùng hóa đơn của đơn vị chủ quản
        đặt in, tự in):
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={agencyName.label}
            name={agencyName.name}
            value={values.agencyName}
            error={errors.agencyName && touched.agencyName}
            success={values.agencyName?.toString().length > 0 && !errors.agencyName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={agencyTax.label}
            name={agencyTax.name}
            error={errors.agencyTax && touched.agencyTax}
            success={values.agencyTax?.toString().length > 0 && !errors.agencyTax}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={sendTo.label}
            name={sendTo.name}
            value={values.sendTo}
            error={errors.sendTo && touched.sendTo}
            success={values.sendTo?.toString().length > 0 && !errors.sendTo}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={representative.label}
            name={representative.name}
            value={values.representative}
            error={errors.representative && touched.representative}
            success={values.representative?.toString().length > 0 && !errors.representative}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={releaseDate.label}
            name={releaseDate.name}
            error={errors.releaseDate && touched.releaseDate}
            success={values.releaseDate?.toString().length > 0 && !errors.releaseDate}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
